function processDnbLabels(word: string, index: number): string {
  if (index === 0 && word === 'DNB') return 'D&B';
  return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
}

export function factKeyToLabel(key: string): string {
  return key.split('_').map(processDnbLabels).join(' ');
}

export function convertFactToSelectOptions<Facts extends Record<string, unknown>>(facts: Facts) {
  return Object.entries(facts).map(([key, value]) => ({
    value: value as Facts[keyof Facts],
    label: factKeyToLabel(key),
  }));
}
